module.exports = __webpack_public_path__ + "static/media/wizualizacja-43.05d7c19f.png";